export default __webpack_public_path__ + "static/media/round.91ddd3a0.webp";